//export const BACKEND_HOST = "http://localhost:3000";
export const BACKEND_HOST = "https://api.hordiyevskyy.com";
